<script>
import Button from "@/shared/ui/button/Button.vue";
import QuickTestamentSearchDrawer from "./QuickTestamentSearchDrawer.vue";
import QuickNdSearchDrawer from "./QuickNdSearchDrawer.vue";
import QuickInheritanceSearchDrawer from "./QuickInheritanceSearchDrawer.vue";

export default {
  name: "QuickActions",
  components: {
    Button,
    QuickTestamentSearchDrawer,
    QuickNdSearchDrawer,
    QuickInheritanceSearchDrawer,
  },

  data() {
    return {
      showTestamentSearch: false,
      showNdSearch: false,
      showInheritanceSearch: false,
    };
  },
  methods: {
    onQuickAction(action) {
      if (action === "nd_search") {
        this.showNdSearch = true;
      } else if (action === "inheritance_search") {
        this.showInheritanceSearch = true;
      } else if (action === "testament_search") {
        this.showTestamentSearch = true;
      } else if (action === "ai-notary") {
        this.$router.push({
          name: "ai-assistant",
        });
      }
    },
  },
  mounted() {},
  computed: {
    isNotary() {
      return this.$store.state.self_user?.role === "NOTARY";
    },
    quickActionsGroups() {
      return [
        {
          title: "AI",
          titleIcon: "",
          items: [
            {
              label: "AI-нотариус",
              icon: "huge-ai",
              action: "ai-notary",
            },
          ],
        },
        {
          title: "Действия",
          titleIcon: "",
          items: [
            {
              label: "Поиск НД",
              icon: "huge-search-file",
              action: "nd_search",
            },
            {
              label: "Поиск наслед. дела",
              icon: "huge-search-file",
              action: "inheritance_search",
            },
            {
              label: "Поиск завещания",
              icon: "huge-search-file",
              action: "testament_search",
            },
          ],
        },
        {
          title: "Движимое и недвижимое имущество",
          titleIcon: "",
          items: [
            { label: "Проверка авто", icon: "huge-car" },
            { label: "Поиск недвижимости", icon: "huge-search-house" },
            // {
            //   label: "Запросы на регистрацию прав на недвижимость",
            //   icon: "huge-house",
            // },
            // {
            //   label: "Запрос на получение справки формы №2",
            //   icon: "huge-docs",
            // },
            // { label: "Поиск прописанных на недвижимости", icon: "huge-people" },
            // { label: "Проверка движимого имущества", icon: "huge-archive" },
          ],
        },
      ];
    },
  },
};
</script>

<template>
  <div class="actions" :class="{ 'actions--wide': !isNotary }">
    <div class="flex justify-between items-center">
      <div class="text-lg leading-6 font-semibold text-foreground">
        {{ $t("Быстрые действия") }}
      </div>
      <Button variant="outline" size="icon">
        <svg-icon name="huge-config" class="w-5 h-5 text-muted-foreground" />
      </Button>
    </div>
    <el-scrollbar class="flex-1 min-h-0">
      <div v-if="quickActionsGroups?.length" class="body">
        <div
          v-for="(group, gIndex) in quickActionsGroups"
          :key="gIndex"
          class="w-full flex flex-col gap-6"
        >
          <div class="title" v-if="group.title">
            <svg-icon
              v-if="group.titleIcon"
              :name="group.titleIcon"
              class="w-5 h-5 text-muted-foreground"
            />
            <p class="text-sm font-medium text-muted-foreground">
              {{ $t(group.title) }}
            </p>
          </div>

          <div v-if="group.items?.length" class="items">
            <div
              v-for="(item, iIndex) in group.items"
              :key="iIndex"
              class="block"
              @click="item.action && onQuickAction(item.action)"
            >
              <svg-icon
                v-if="item.icon"
                :name="item.icon"
                class="w-5 h-5 text-muted-foreground fill-none"
              />

              <p
                class="text"
                :title="item.label ? $t(item.label) : $t('не указано')"
              >
                {{ item.label ? $t(item.label) : $t("не указано") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <QuickTestamentSearchDrawer
      v-if="showTestamentSearch"
      @close="showTestamentSearch = false"
    />

    <QuickNdSearchDrawer v-if="showNdSearch" @close="showNdSearch = false" />

    <QuickInheritanceSearchDrawer
      v-if="showInheritanceSearch"
      @close="showInheritanceSearch = false"
    />
  </div>
</template>

<style scoped lang="scss">
.actions {
  @apply flex flex-col  gap-8 bg-card;

  @media (min-width: 1400px) {
    @apply max-w-[466px] min-h-0 overflow-hidden px-6;
  }

  &--wide {
    @media (min-width: 1400px) {
      @apply max-w-none w-full px-0;
    }

    .body {
      @apply flex-row flex-wrap;

      > * {
        @apply w-auto flex-1 min-w-[280px];
      }
    }
  }

  .btn {
    @apply w-14 flex justify-center items-center py-[10px] px-4 rounded-full cursor-pointer;
    border: 1px solid rgba(0, 0, 0, 0.06);

    svg {
      color: hsl(var(--muted-foreground));
    }
    &:hover {
      @apply hover:bg-muted;
    }
  }
  .body {
    @apply flex flex-col items-start gap-6 self-stretch;

    flex: 1 0 0;

    .title {
      @apply flex items-start gap-3 self-stretch;
    }

    .items {
      @apply flex items-start gap-3 content-start flex-wrap self-stretch;

      .block {
        @apply h-24 w-[203px] flex flex-col justify-center items-start p-3 gap-3 bg-muted/30;
        @apply cursor-pointer;
        border-radius: var(--radius);
        //background-color: hsl(var(--background));
        border: 1px solid hsl(var(--border));
        &:hover {
          @apply hover:bg-muted;
        }
        .text {
          @apply text-sm font-medium text-foreground self-stretch line-clamp-2;
        }
      }
    }
  }
}
</style>
